module.exports = __webpack_public_path__ + "static/krzysiek-59d486bf00481033ff030cc74189bb44.webp";